module.exports = __webpack_public_path__ + "media/reskin-images/icon--map-pin-add3418b.svg";